export default class CardComparison {
  constructor() {
    var buttonRemove = document.querySelector('.card__remove');
    if(typeof(buttonRemove) != 'undefined' && buttonRemove != null) {
      console.log('bind');
      this.bindEvents();
    }
  }

  bindEvents() {
    var buttonRemove = document.querySelectorAll('.card__remove');

    buttonRemove.forEach(remove => {
      remove.addEventListener('click', function() {
        var node = this.parentNode.parentNode;

        node.style.width = 0;
        node.style.minWidth = 0;
        node.style.margin = 0;
        node.style.opacity = 0;

        setTimeout(function() {
          node.remove();      
        }, 500);

        if(document.querySelectorAll('.card--comparison .card__remove').length == 1) {
          window.location.href = "/tests-products.html#comparison-anchor";
        }
      });
    });
  }
}

$(document).ready(function() {
  const cardComparison = new CardComparison();
});